import { render, staticRenderFns } from "./SingleCalendar.vue?vue&type=template&id=876e9fd8"
import script from "./SingleCalendar.vue?vue&type=script&lang=js"
export * from "./SingleCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports